import Vue from 'vue';
import { Message } from 'element-ui';
import { isEmpty } from 'lodash-es';
import NProgress from 'nprogress';
import 'nprogress/nprogress.css';
import router from './router';

NProgress.configure({ showSpinner: false });

export const whiteList = [
  '/login',
  '/login-guian',
  '/auth-redirect',
  '/bind',
  '/register',
  '/404',
  '/asset/dataCompartmentV2Mobile',
  '/asset/dataCompartmentV2Mobile/',
  '/asset/dataCompartmentScreen',
  '/asset/dataCompartmentScreen/',
  '/asset/assetFiles/house/detail/mobile'
];

router.beforeEach(async (to: any, _from, next) => {
  await NProgress.start();

  if (to.meta.title) {
    document.title = `${to.meta.title}-${import.meta.env.ROSA_TITLE}`;
  }

  /* 处理用户手动修改分页size不合法的情况 */
  if (to.query?.size) {
    let num = Number(to.query?.size);
    if (isNaN(num) || num <= 0) {
      to.query.size = 10;
      next({ ...to, query: { ...to.query, size: 10 } });
    }
  }

  /* 处理用户手动修改分页current不合法的情况 */
  if (to.query?.current) {
    let num = Number(to.query?.current);
    if (isNaN(num) || num <= 0) {
      to.query.current = 1;
      next({ ...to, query: { ...to.query, current: 1 } });
    }
  }

  const loginPage = useLoginPage();
  const appStore = useAppStore();
  const userStore = useUserStore();
  const dictStore = useDictStore();
  const routerStore = useRouterStore();
  const { showLockScreen } = storeToRefs(appStore);

  if (userStore.token) {
    if (to.path === loginPage) {
      next({ path: '/' });
    } else {
      try {
        if (isEmpty(dictStore.sysDict)) {
          await dictStore.getSysDict();
          Vue.prototype.$zcDict = dictStore.zcDict;
        }

        if (!routerStore.sysRouter) {
          const router = await routerStore.getSysRouter();
          if (isEmpty(router)) throw new Error('getSysRouter: router is empty!');
        }

        if (!userStore.roles) {
          const { roles } = await userStore.getInfo();
          if (isEmpty(roles)) throw new Error('getInfo: user has no roles!');
          console.table([...roles]);
        }

        if (to.name === 'index') {
          next({ path: routerStore.defaultRoute, replace: true });
        } else {
          next();
        }
      } catch (error) {
        userStore.clearInfo();
        return Message.warning('对不起，您没有访问权限，请联系管理员添加角色');
      }
    }
  } else {
    if (import.meta.env.ROSA_IS_SSO !== 'TRUE') {
      if (whiteList.indexOf(to.path) !== -1) {
        next();
      } else if (!showLockScreen.value) {
        next(`${loginPage}?redirect=${to.fullPath}`);
      }
    } else {
      // cas配置
      location.replace(import.meta.env.ROSA_SSO_URL);
    }
  }
});

router.afterEach((_to, from) => {
  NProgress.done();
  if (from.path === '/') return;
});

const matchPermission = (allPerms: string[], perm: string) => {
  const permArr: any[] = [perm];
  const splitPerm = perm.split(':');
  for (let i = 1; i < splitPerm.length; i++) {
    permArr.push(splitPerm.fill('*', splitPerm.length - i).join(':'));
  }
  for (const p of permArr) {
    if (allPerms.includes(p)) return true;
  }
  return permArr.some((p) => allPerms.includes(p));
};

export const hasPerm = (perm: string) => {
  const { permissions } = storeToRefs(useUserStore());
  if (permissions.value.includes('*:*:*')) return true;
  return matchPermission(permissions.value, perm);
};

export const noPerm = (perm: string) => {
  const { permissions } = storeToRefs(useUserStore());
  if (permissions.value.includes('*:*:*')) return false;
  return !matchPermission(permissions.value, perm);
};

export const permissionPlugin = {
  install(app: any, _options: Record<string, any>) {
    app.directive('auth', {
      inserted(el: Element, { value, arg }: any) {
        switch (arg) {
          case 'no':
            if (hasPerm(value)) el.parentNode?.removeChild(el);
            break;
          default:
            if (hasPerm(value)) return;
            el.parentNode?.removeChild(el);
        }
      },
    });
  },
};

Vue.use(permissionPlugin);
